import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, FEDERATION } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

function formatErr(d) {
  if (!d) return 'Login failed';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return d.msg || JSON.stringify(d);
}

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setBusy(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('psf_token', data.access_token);
      navigate('/admin', { replace: true });
    } catch (ex) {
      setErr(formatErr(ex?.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6 grain" data-testid="admin-login">
      <form onSubmit={submit} className="w-full max-w-md border border-[#CCFF00]/40 bg-[#141414] p-8 space-y-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#CCFF00]">{FEDERATION.short} · Admin</p>
        <h1 className="font-display uppercase text-3xl md:text-4xl leading-tight">Control Room</h1>
        <p className="text-white/60 text-sm">Owner-only access. 5 wrong tries locks the account for 15 min.</p>
        <div>
          <Label className="text-[10px] font-mono uppercase tracking-widest text-white/60">Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black border-white/20 rounded-none mt-1" data-testid="admin-email" required />
        </div>
        <div>
          <Label className="text-[10px] font-mono uppercase tracking-widest text-white/60">Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black border-white/20 rounded-none mt-1" data-testid="admin-password" required />
        </div>
        {err && <p className="text-sm text-[#FF3B30] font-mono" data-testid="admin-error">{err}</p>}
        <button type="submit" disabled={busy} className="w-full bg-[#CCFF00] text-black py-3 font-mono text-xs uppercase tracking-widest hover:bg-white disabled:opacity-50" data-testid="admin-submit">
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </main>
  );
}
